(function () {
  'use strict';

  var CARD = '[data-atlekx-card]';
  var QUICK_BTN = '.quick-product__btn';
  var states = new WeakMap();

  function parseVariants(card) {
    var node = card.querySelector('[data-atlekx-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function getIndex(card, attr) {
    var raw = card.getAttribute(attr);
    if (raw === null || raw === '') return -1;
    var n = parseInt(raw, 10);
    return isNaN(n) ? -1 : n;
  }

  function cardHost(card) {
    return card.closest('.grid-product') || card.parentElement;
  }

  function findCardImage(card) {
    var host = cardHost(card);
    if (!host) return null;
    return host.querySelector('.grid__item-image-wrapper img');
  }

  function swapImage(card, src) {
    if (!src) return;
    var img = findCardImage(card);
    if (!img) return;
    if (img.getAttribute('data-atlekx-saved') !== 'true') {
      img.setAttribute('data-atlekx-saved', 'true');
      img.setAttribute('data-atlekx-src', img.getAttribute('src') || '');
      img.setAttribute('data-atlekx-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-atlekx-sizes', img.getAttribute('sizes') || '');
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  }

  function matchingVariants(variants, colorIndex, color) {
    if (colorIndex < 0 || !color) return variants;
    return variants.filter(function (v) {
      return v.opts[colorIndex] === color;
    });
  }

  function resolveVariant(state) {
    var pool = matchingVariants(state.variants, state.colorIndex, state.color);
    if (state.sizeIndex < 0) {
      var firstAvailable = pool.filter(function (v) {
        return v.av;
      })[0];
      return firstAvailable || pool[0] || null;
    }
    if (!state.size) return null;
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].opts[state.sizeIndex] === state.size) return pool[i];
    }
    return null;
  }

  function refreshSizes(card, state) {
    var buttons = card.querySelectorAll('[data-atlekx-size]');
    if (!buttons.length) return;
    var pool = matchingVariants(state.variants, state.colorIndex, state.color);

    Array.prototype.forEach.call(buttons, function (btn) {
      var value = btn.getAttribute('data-atlekx-size');
      var available = pool.some(function (v) {
        return v.opts[state.sizeIndex] === value && v.av;
      });
      btn.classList.toggle('is-unavailable', !available);
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (!available && state.size === value) {
        state.size = null;
        btn.classList.remove('is-active');
      }
    });
  }

  function labelFor(state) {
    if (state.variantId) return state.labelDefault;
    if (state.sizeIndex >= 0 && !state.size) return state.labelPickSize;
    return state.labelSoldOut;
  }

  function coversAllOptions(state) {
    var controlled = 0;
    if (state.colorIndex >= 0) controlled++;
    if (state.sizeIndex >= 0) controlled++;
    return state.totalOptions > 0 && controlled >= state.totalOptions;
  }

  function canAdd(state) {
    if (!state.touched) return false;
    if (!coversAllOptions(state)) return false;
    if (!state.variantId) return false;
    if (state.sizeIndex >= 0 && !state.size) return false;
    return true;
  }

  function refreshButton(card, state) {
    var variant = resolveVariant(state);
    state.variantId = variant && variant.av ? variant.id : null;

    var own = card.querySelector('[data-atlekx-atc]');
    if (own && own.getAttribute('data-atlekx-state') === null) {
      own.disabled = !state.variantId;
      own.textContent = labelFor(state);
    }

    if (state.quickHook) {
      var quick = quickButtonFor(card);
      if (quick && quick.getAttribute('data-atlekx-state') === null) {
        if (canAdd(state)) {
          quick.textContent = state.labelDefault;
          quick.setAttribute('data-atlekx-ready', 'true');
          quick.removeAttribute('aria-expanded');
        } else {
          quick.textContent = state.labelQuick;
          quick.removeAttribute('data-atlekx-ready');
          if (quick.classList.contains('js-modal-open-quick-modal-' + card.getAttribute('data-product-id'))) {
            quick.setAttribute('aria-expanded', 'false');
          }
        }
      }
    }
  }

  function quickButtonFor(card) {
    var host = cardHost(card);
    return host ? host.querySelector(QUICK_BTN) : null;
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  function refreshCartCount() {
    var hasDrawer = window.theme && theme.settings && theme.settings.cartType === 'drawer';
    if (hasDrawer) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble-num'), function (el) {
          el.textContent = cart.item_count;
        });
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble'), function (el) {
          el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  function addToCart(card, state, btn) {
    if (!state.variantId || !btn) return;

    var restore = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('data-atlekx-state', 'loading');
    btn.textContent = state.labelAdding;

    fetch(cartUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function () {
        btn.setAttribute('data-atlekx-state', 'added');
        btn.textContent = state.labelAdded;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        refreshCartCount();
        window.setTimeout(function () {
          btn.removeAttribute('data-atlekx-state');
          btn.disabled = false;
          btn.textContent = restore;
          refreshButton(card, state);
        }, 1800);
      })
      .catch(function () {
        btn.setAttribute('data-atlekx-state', 'error');
        btn.textContent = state.labelError;
        window.setTimeout(function () {
          btn.removeAttribute('data-atlekx-state');
          btn.disabled = false;
          btn.textContent = restore;
          refreshButton(card, state);
        }, 2200);
      });
  }

  function initCard(card) {
    if (card.getAttribute('data-atlekx-ready') === 'true') return;
    card.setAttribute('data-atlekx-ready', 'true');

    var state = {
      variants: parseVariants(card),
      colorIndex: getIndex(card, 'data-color-index'),
      sizeIndex: getIndex(card, 'data-size-index'),
      color: card.getAttribute('data-initial-color') || null,
      totalOptions: parseInt(card.getAttribute('data-total-options'), 10) || 0,
      touched: false,
      size: null,
      variantId: null,
      quickHook: card.getAttribute('data-quickshop-hook') === 'true',
      labelDefault: card.getAttribute('data-label-add') || 'Agregar',
      labelPickSize: card.getAttribute('data-label-pick') || 'Elige una talla',
      labelSoldOut: card.getAttribute('data-label-soldout') || 'Agotado',
      labelAdding: card.getAttribute('data-label-adding') || 'Agregando...',
      labelAdded: card.getAttribute('data-label-added') || 'Agregado',
      labelError: card.getAttribute('data-label-error') || 'Intenta de nuevo',
      labelQuick: card.getAttribute('data-label-quick') || 'Compra rapida'
    };

    if (!state.variants.length) return;
    states.set(card, state);

    var fallbackBtn = card.querySelector('[data-atlekx-fallback]');
    if (fallbackBtn) {
      if (state.quickHook && quickButtonFor(card)) {
        fallbackBtn.remove();
      } else {
        fallbackBtn.removeAttribute('hidden');
        fallbackBtn.removeAttribute('data-atlekx-fallback');
        state.quickHook = false;
      }
    }

    card.addEventListener('click', function (event) {
      var moreBtn = event.target.closest('[data-atlekx-more]');
      if (moreBtn && card.contains(moreBtn)) {
        event.preventDefault();
        event.stopPropagation();
        Array.prototype.forEach.call(card.querySelectorAll('.atlekx-card__color--extra'), function (b) {
          b.removeAttribute('hidden');
          b.classList.remove('atlekx-card__color--extra');
        });
        moreBtn.setAttribute('aria-expanded', 'true');
        moreBtn.remove();
        return;
      }

      var colorBtn = event.target.closest('[data-atlekx-color]');
      if (colorBtn && card.contains(colorBtn)) {
        event.preventDefault();
        event.stopPropagation();
        state.touched = true;
        state.color = colorBtn.getAttribute('data-atlekx-color');
        Array.prototype.forEach.call(card.querySelectorAll('[data-atlekx-color]'), function (b) {
          b.classList.toggle('is-active', b === colorBtn);
        });
        swapImage(card, colorBtn.getAttribute('data-atlekx-image'));
        refreshSizes(card, state);
        refreshButton(card, state);
        return;
      }

      var sizeBtn = event.target.closest('[data-atlekx-size]');
      if (sizeBtn && card.contains(sizeBtn)) {
        event.preventDefault();
        event.stopPropagation();
        if (sizeBtn.classList.contains('is-unavailable')) return;
        state.touched = true;
        state.size = sizeBtn.getAttribute('data-atlekx-size');
        Array.prototype.forEach.call(card.querySelectorAll('[data-atlekx-size]'), function (b) {
          b.classList.toggle('is-active', b === sizeBtn);
        });
        refreshButton(card, state);
        return;
      }

      var atcBtn = event.target.closest('[data-atlekx-atc]');
      if (atcBtn && card.contains(atcBtn)) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(card, state, atcBtn);
      }
    });

    refreshSizes(card, state);
    refreshButton(card, state);
  }

  document.addEventListener(
    'click',
    function (event) {
      var quick = event.target.closest(QUICK_BTN);
      if (!quick) return;

      var fallbackUrl = quick.getAttribute('data-atlekx-quickview-url');

      var host = quick.closest('.grid-product');
      if (!host) {
        if (fallbackUrl) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = fallbackUrl;
        }
        return;
      }

      var card = host.querySelector(CARD);
      if (!card) return;

      var state = states.get(card);

      if ((!state || !state.quickHook || !canAdd(state)) && fallbackUrl) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        window.location.href = fallbackUrl;
        return;
      }

      if (!state || !state.quickHook) return;

      if (!canAdd(state)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addToCart(card, state, quick);
    },
    true
  );

  /* ------------------------------------------------------------------
     Vista rapida ("LO QUIERO")
     - El modal se precarga cuando la tarjeta entra en pantalla (escritorio),
       asi que al pasar el cursor normalmente ya esta listo.
     - Una sola peticion por producto aunque se pase el cursor varias veces.
     - Si se hace clic antes de que este listo, el boton muestra un spinner
       y el modal se abre solo en cuanto termina de cargar.
     ------------------------------------------------------------------ */
  var quickJobs = {};
  var quickQueue = [];
  var quickActive = 0;
  var quickObserver = null;
  var QUICK_MAX_PARALLEL = 2;

  function quickViewUrl(handle) {
    var root = (window.theme && theme.routes && theme.routes.home) || '';
    return (root + '/products/' + handle).replace('//', '/');
  }

  function quickButtonsFor(productId) {
    return document.querySelectorAll('.js-modal-open-quick-modal-' + productId);
  }

  function preloadQuickView(handle, productId) {
    var holder = handle ? document.getElementById('QuickShopHolder-' + handle) : null;
    if (!holder) return Promise.resolve(false);
    if (holder.getAttribute('data-atlekx-quickview') === 'ready') return Promise.resolve(true);
    if (quickJobs[handle]) return quickJobs[handle];

    var job = fetch(quickViewUrl(handle) + '?view=modal', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;

        var node =
          html.querySelector('.product-section[data-product-handle="' + handle + '"]') ||
          html.querySelector('.product-section') ||
          html.querySelector('[data-section-type="product"]');

        if (!node) throw new Error('sin product-section');

        holder.innerHTML = '';
        holder.appendChild(node);

        try {
          new theme.Modals('QuickShopModal-' + productId, 'quick-modal-' + productId);
        } catch (e) {}
        try {
          theme.sections.register('product', theme.Product, holder);
        } catch (e) {}
        try {
          theme.collapsibles.init();
        } catch (e) {}
        try {
          theme.videoModal();
        } catch (e) {}

        holder.setAttribute('data-atlekx-quickview', 'ready');
        return true;
      })
      .catch(function () {
        delete quickJobs[handle];
        holder.setAttribute('data-atlekx-quickview', 'failed');
        Array.prototype.forEach.call(quickButtonsFor(productId), function (btn) {
          btn.classList.remove('btn--not-ready');
          btn.setAttribute('data-atlekx-quickview-url', quickViewUrl(handle));
        });
        return false;
      });

    quickJobs[handle] = job;
    return job;
  }

  function patchThemeQuickView() {
    if (!window.theme || typeof theme.preloadProductModal !== 'function') return;
    if (theme.preloadProductModal.atlekxPatched) return;

    var patched = function (handle, productId) {
      return preloadQuickView(handle, productId);
    };
    patched.atlekxPatched = true;
    theme.preloadProductModal = patched;
  }

  function quickViewDesktop() {
    if (!window.theme || !theme.settings || !theme.settings.quickView) return false;
    if (theme.config && theme.config.isTouch) return false;
    if (!window.matchMedia) return true;
    if (window.matchMedia('(max-width: 768px)').matches) return false;
    if (!window.matchMedia('(hover: hover)').matches) return false;
    return true;
  }

  function pumpQuickQueue() {
    while (quickActive < QUICK_MAX_PARALLEL && quickQueue.length) {
      var host = quickQueue.shift();
      if (!document.contains(host)) continue;
      quickActive++;
      preloadQuickView(host.getAttribute('data-product-handle'), host.getAttribute('data-product-id')).then(quickDone, quickDone);
    }
  }

  function quickDone() {
    quickActive = Math.max(0, quickActive - 1);
    pumpQuickQueue();
  }

  function observeQuickCards(scope) {
    if (!quickViewDesktop() || !('IntersectionObserver' in window)) return;

    if (!quickObserver) {
      quickObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            quickObserver.unobserve(entry.target);
            quickQueue.push(entry.target);
          });
          pumpQuickQueue();
        },
        { rootMargin: '160px 0px' }
      );
    }

    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('.grid-product[data-product-handle]'), function (host) {
      if (host.getAttribute('data-atlekx-qv') === 'observed') return;
      if (!host.querySelector(QUICK_BTN)) return;
      if (host.closest('.product-recommendations-placeholder')) return;
      host.setAttribute('data-atlekx-qv', 'observed');
      quickObserver.observe(host);
    });
  }

  // Clic en "LO QUIERO" antes de que el modal este listo: spinner y apertura automatica
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(QUICK_BTN);
      if (!btn || !btn.classList.contains('btn--not-ready')) return;
      if (btn.getAttribute('data-atlekx-quickview-url')) return;

      var host = btn.closest('.grid-product');
      if (!host) return;

      var handle = host.getAttribute('data-product-handle');
      var productId = host.getAttribute('data-product-id');
      if (!handle || !productId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (btn.getAttribute('data-atlekx-waiting') === 'true') return;
      btn.setAttribute('data-atlekx-waiting', 'true');
      btn.classList.add('btn--loading');

      preloadQuickView(handle, productId).then(function (ok) {
        btn.classList.remove('btn--loading');
        btn.removeAttribute('data-atlekx-waiting');
        if (ok && !btn.classList.contains('btn--not-ready')) {
          btn.click();
        } else if (!ok) {
          window.location.href = quickViewUrl(handle);
        }
      });
    },
    true
  );

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(CARD), initCard);
  }

  function boot(scope) {
    patchThemeQuickView();
    initAll(scope || document);
    observeQuickCards(scope || document);
  }

  // Los scripts "defer" corren antes de DOMContentLoaded y theme.js se carga
  // despues de este archivo, asi que esperamos a DOMContentLoaded para que
  // theme.preloadProductModal ya exista y se pueda reemplazar.
  if (document.readyState === 'complete') {
    boot(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  document.addEventListener('collection:reloaded', function () {
    boot(document);
  });
  document.addEventListener('recommendations:loaded', function () {
    boot(document);
  });
})();
